import React from 'react';
import { Box } from '@mui/material';

/**
 * Fields that belong together, across the screen rather than down it.
 *
 * A desk form of twenty stacked fields is a form somebody scrolls while a lorry waits. Pairing the
 * short ones uses the width a desk actually has, and collapses back to one column on a phone in the
 * gate hut, where side by side would mean two fields too narrow to read.
 *
 * `columns` takes the shape of the row - '1fr 1fr' for a pair, '2fr 1fr 1fr' where one field is a
 * description and the others are a number and its unit.
 */
const FormRow = ({ columns = '1fr 1fr', children }) => (
  <Box sx={{
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', sm: columns },
    gap: 2.5,
    alignItems: 'start',
  }}
  >
    {children}
  </Box>
);

export default FormRow;
